import type { ReactNode } from "react";
import type { Components } from "react-markdown";

import { createContext, useContext, useMemo } from "react";

import type { PluggableList } from "unified";

interface MarkdownContextValue {
  components?: Components;
  rehypePlugins?: PluggableList;
}

const MarkdownContext = createContext<MarkdownContextValue | null>(null);

interface MarkdownContextProviderProps {
  children: ReactNode;
  value: MarkdownContextValue;
}

export const MarkdownContextProvider = ({
  children,
  value,
}: MarkdownContextProviderProps) => {
  const context = useMarkdownContext();

  const mergedValue = useMemo(
    () => ({
      ...context,
      ...value,
      components: {
        ...context?.components,
        ...value.components,
      },
    }),
    [context, value],
  );

  return <MarkdownContext value={mergedValue}>{children}</MarkdownContext>;
};

export const useMarkdownContext = () => {
  const context = useContext(MarkdownContext);

  return context;
};
